<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Profile
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                color="transparent">
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                      class="py-0">
                      <v-card 
                        flat
                        class="on-scroll-sticky"
                        style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-list 
                          flat 
                          two-line
                          color="transparent">
                          <v-list-item>
                            <v-list-item-avatar 
                              tile 
                              size="40" 
                              class="my-0 mr-3">
                              <v-img 
                                width="100%"
                                height="100%"
                                alt="tiketinaja"
                                style="border-radius: 10px;"
                                :src="require('@/assets/image/member_default.png')">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title 
                                class="body-2 text-capitalize font-weight-bold"
                                style="margin-bottom: 5px;">
                                {{ form.full_name }}
                              </v-list-item-title>

                              <v-list-item-subtitle 
                                class="caption text-capitalize">
                                {{ form.email }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>

                        <v-divider
                          class="mb-4"
                          style="border-top: 2px dashed #EBEBEB;" />

                        <div
                          v-for="(item, index) in menu"
                          :key="index">
                          <div 
                            class="px-4">
                            <div 
                              @click="selected.menu = index; changeQuery(item.link);"
                              class="body-2 d-flex align-center cursor-pointer"
                              :class="index < menu.length - 1 ? 'mb-3' : 'mb-5'">
                              <v-icon 
                                small 
                                :color="selected.menu === index ? set_color : ''"
                                :style="selected.menu === index ? `` : 'opacity: 80%;'">
                                {{ item.icon }}
                              </v-icon>

                              <span 
                                class="ml-2"
                                :style="selected.menu === index ? `color: ${set_color}; font-weight: 600;` : 'opacity: 60%;'">
                                {{ item.text }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col
                      cols="12"
                      md="9"
                      class="py-0">
                      <v-card 
                        flat
                        color="transparent"
                        class="on-scroll-sticky">
                        <General v-if="selected.menu === 0"
                          :form="form" />

                        <Password v-if="selected.menu === 1" />
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        menu: [
          {
            text: 'Profil Saya',
            icon: 'mdi-account-reactivate-outline',
            link: '/profile?menu=profile'
          },
          {
            text: 'Password',
            icon: 'mdi-shield-key-outline',
            link: '/profile?menu=password'
          }
        ],

        form: {},

        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      General: () => import(/* webpackPrefetch: true */ '@/components/profile/general.vue'),
      Password: () => import(/* webpackPrefetch: true */ '@/components/profile/password.vue')
    },
    watch: {
      '$route.query.menu': function(val) {
        this.changeLink(val)
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      this.changeLink(this.$route.query.menu)
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        await get(`admin/profile/detail`)
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.form = res.result
          }
        })
      },

      changeLink (query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        if (query !== undefined) {
          this.selected.menu = query === 'profile' ? 0 : 1
        }
      },
      changeQuery (link) {
        this.$router.push(link)
      }
    }
  }
</script>